"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useHasErrors = require("../../../common/useHasErrors");
var _PhoneFormatter = _interopRequireDefault(require("../../../common/Formatters/PhoneFormatter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.GSemployeeRole-container {\n  box-sizing: content-box;\n  margin: auto; }\n  .GSemployeeRole-container .info-container {\n    max-width: 100%;\n    width: 244px; }\n  .GSemployeeRole-container img {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 1;\n    object-fit: cover; }\n  .GSemployeeRole-container .name {\n    margin-bottom: 0px;\n    width: auto;\n    max-width: 100%; }\n  .GSemployeeRole-container .lastname {\n    width: auto;\n    max-width: 100%; }\n  .GSemployeeRole-container .professional_function {\n    max-width: 204px; }\n  .GSemployeeRole-container .diploma_title {\n    margin-top: 2px; }\n  .GSemployeeRole-container .phone {\n    text-decoration: underline; }\n  @media (max-width: 66rem) {\n    .GSemployeeRole-container .info-container {\n      max-width: 100%;\n      width: 312px;\n      margin-left: 0px; } }\n  @media (max-width: 42rem) {\n    .GSemployeeRole-container .info-container {\n      max-width: 100%;\n      width: 288px;\n      margin-left: 0px; } }\n";
  const fileName = "GSemployeeRole_GSemployeeRole";
  const element = document.querySelector("style[data-sass-component='GSemployeeRole_GSemployeeRole']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const requiredProps = ['firstname', 'lastname', 'email'];
const GSemployeeRole = props => {
  const {
    picture,
    firstname,
    lastname,
    professional_function,
    diploma_title,
    phone,
    mobile,
    email,
    gender,
    displayImage = true
  } = props;
  const defaultImage = `/images/defaultEmployee_${gender}.jpg`;
  const src = picture || defaultImage;
  const hasErrors = (0, _useHasErrors.useHasErrors)(requiredProps, props);
  if (hasErrors) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "GSemployeeRole-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "info-container sia-margin-02-left sia-border-01-bottom sia-padding-04-bottom sia-margin-02-bottom"
  }, displayImage && src && /*#__PURE__*/_react.default.createElement("img", {
    className: "sia-margin-02-bottom",
    src: src,
    alt: firstname,
    onError: e => {
      console.error(e);
      e.target.src = defaultImage;
    }
  }), /*#__PURE__*/_react.default.createElement("h3", {
    className: "name sia-text-12"
  }, firstname), /*#__PURE__*/_react.default.createElement("h3", {
    className: "lastname sia-text-12 sia-margin-02-bottom"
  }, lastname), /*#__PURE__*/_react.default.createElement("p", {
    className: "professional_function sia-text-03",
    dangerouslySetInnerHTML: {
      __html: professional_function
    }
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "diploma_title sia-text-08"
  }, diploma_title), /*#__PURE__*/_react.default.createElement("p", {
    className: "phone sia-text-08 sia-margin-02-top"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: `tel:${phone?.replaceAll(' ', '')}`
  }, _PhoneFormatter.default.format(phone))), /*#__PURE__*/_react.default.createElement("p", {
    className: "phone sia-text-08 sia-margin-02-top"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: `tel:${mobile?.replaceAll(' ', '')}`
  }, _PhoneFormatter.default.format(mobile))), /*#__PURE__*/_react.default.createElement("p", {
    className: "email sia-text-08 sia-margin-02-top"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: `mailto:${email}`
  }, "E-Mail"))));
};
GSemployeeRole.propTypes = {
  picture: _propTypes.default.string,
  firstname: _propTypes.default.string,
  lastname: _propTypes.default.string,
  professional_function: _propTypes.default.string,
  diploma_title: _propTypes.default.string,
  email: _propTypes.default.string,
  phone: _propTypes.default.string,
  mobile: _propTypes.default.string,
  gender: _propTypes.default.string
};
GSemployeeRole.defaultProps = {
  gender: 'F'
};
var _default = exports.default = GSemployeeRole;